export default "__VITE_ASSET__CrjZaAjH__"